import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";

import Button from "components/Chakra/Button";
import CustomLink from "components/Chakra/CustomLink";
import {
  useModal,
  useCreateModal,
  InitialUseCreateModalType,
} from "../ModalsProvider";

const WatchdogCreatedModal: React.FC = () => {
  const { closeAllModals } = useModal("watchdogCreatedModal");

  return (
    <Box textAlign="center" data-test="dogSuccesModal">
      <Heading as="h3" mb={5} data-test="dogHeadingSuccessModal">
        Pes už je na lovu!
      </Heading>

      <Text data-test="dogSuccessText">
        Seznam všech psů a možnosti úprav najdete na stránce{" "}
        <CustomLink to="/hlidaci-pes" onClick={closeAllModals} showUnderline>
          Hlídací pes.
        </CustomLink>
      </Text>

      <Button
        data-test="dogSuccessConfirmButton"
        mt={8}
        onClick={closeAllModals}
      >
        Paráda
      </Button>
    </Box>
  );
};

export const useWatchdogCreatedModal: InitialUseCreateModalType = () =>
  useCreateModal("watchdogCreatedModal", WatchdogCreatedModal, null, null, {
    size: "md",
  });
